<template>
  <v-app light>
    <Alerts></Alerts>
      <v-content>
        <NavigationDrawer ref="drawer" v-if="mostrarDrawer && loggedIn"/>
        <Toolbar v-if="mostrarDrawer"/>
        <router-view></router-view>
      </v-content>
  </v-app>
</template>

<script>
  import NavigationDrawer from '@/components/NavigationDrawer'
  import Toolbar from '@/components/Toolbar'
  import Alerts from '@/components/Alerts'

  import { mapGetters, mapActions } from 'vuex'
  import { necesitaAuth } from '@/router/index'

  export default {
    components: {
      NavigationDrawer,
      Toolbar,
      Alerts
    },
    async created () {
      try {
        await this.restaurarSesion()
        await this.setearRol()
        await this.setLoaded(true)
         if (this.loggedIn) {
          await this.obtenerTiposSolicitud()
          await this.guardarTraduccionesPorDefecto()
          await this.cierreAutomaticoIncidencias()
          await this.obtenerConfiguracion()
          await this.obtenerVersionWS()
          if(this.rolAdmin === true)
          {
            this.$router.push({name: 'gestion'})
          }
          if(this.rolAdmin === false){
            this.$router.push({name: 'home'})
          }        
         }
        if (this.necesitaAuthComputed && !this.loggedIn) {
          this.addNotLoggedInAlert()
          this.$router.push({name: 'login'})
        } else if (this.necesitaAuthComputed && this.passwordUsoUnico && this.$route.name !== 'login.modificarPassword') {
          this.$router.push({name: 'login.modificarPassword'})
        }
      } catch (error) {
        this.addNotLoggedInAlert()
        this.$router.push({name: 'login'})
      }
    },
    methods: {
      ...mapActions({
        comprobarSesion: 'login/comprobarSesion',
        restaurarSesion: 'login/restaurarSesion',
        guardarTraduccionesPorDefecto: 'configuracion/guardarTraduccionesPorDefecto',
        setLoaded: 'login/setLoaded',
        obtenerTiposSolicitud: 'configuracion/obtenerTiposSolicitud',
        addNotLoggedInAlert: 'alerts/addNotLoggedIn',
        addAlert: 'alerts/add',
        cierreAutomaticoIncidencias: 'incidencias/cierreAutomaticoIncidencias',
        obtenerVersionWS: 'obtenerVersionWS',
        obtenerConfiguracion: 'configuracion/obtenerConfiguracion',
        setearRol: 'login/setearRol'
      })
    },
    computed: {
      ...mapGetters({
        loggedIn: 'login/loggedIn',
        loaded: 'login/loaded',
        passwordUsoUnico: 'login/passwordUsoUnico'
      }),
      mostrarDrawer () {
        return this.$route.name === null || !this.$route.name.startsWith('login')
      },
      necesitaAuthComputed () {
        return necesitaAuth(this.$route.name)
      },
      rolAdmin () {
      return this.$store.state.login.rolAdmin
      }
    }
  }
</script>

<style>
.v-data-table-header th {
  white-space: nowrap;
}

:focus{
  outline: 0px;
}

*{
    font-family: 'proxima_nova_altregular';
    font-weight: normal;
    font-style: normal;
        /* Support for all WebKit browsers. */
    -webkit-font-smoothing: antialiased;
    /* Support for Safari and Chrome. */
    text-rendering: optimizeLegibility;

    /* Support for Firefox. */
    -moz-osx-font-smoothing: grayscale;

    /* Support for IE. */
    font-feature-settings: 'liga';
}
@font-face {
    font-family: 'proxima_nova_altblack';
    src:url('~@/assets/fonts/ProximaNova/ProximaNovaAltBlack.woff2') format('woff2'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaAltBlack.woff') format('woff'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaAltBlack.ttf') format('truetype'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaAltBlack.svg#proxima_nova_altblack') format('svg');
    font-weight: normal;
    font-style: normal;
}
@font-face {
  font-family: 'proxima_nova_altbold';
  src: url('~@/assets/fonts/ProximaNova/ProximaNovaAltBold.woff2') format('woff2'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaAltBold.woff') format('woff'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaAltBold.ttf') format('truetype'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaAltBold.svg#proxima_nova_altbold') format('svg');
  font-weight: normal;
  font-style: normal;
}

@font-face {
    font-family: 'proxima_nova_altregular';
    src:  url('~@/assets/fonts/ProximaNova/ProximaNovaAltRegular.eot');
    src:  url('~@/assets/fonts/ProximaNova/ProximaNovaAltRegular.eot?#iefix') format('embedded-opentype'),
          url('~@/assets/fonts/ProximaNova/ProximaNovaAltRegular.woff2') format('woff2'),
          url('~@/assets/fonts/ProximaNova/ProximaNovaAltRegular.woff') format('woff'),
          url('~@/assets/fonts/ProximaNova/ProximaNovaAltRegular.ttf') format('truetype'),
          url('~@/assets/fonts/ProximaNova/ProximaNovaAltRegular.svg#proxima_nova_altregular') format('svg');
    font-weight: normal;
    font-style: normal;
}

/* Generated by Font Squirrel (http://www.fontsquirrel.com) on April 4, 2015 */


@font-face {
    font-family: 'proxima_nova_ltsemibold';
    src: url('~@/assets/fonts/ProximaNova/ProximaNovaSemibold.woff2') format('woff2'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaSemibold.ttf') format('truetype'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaSemibold.svg#proxima_nova_ltsemibold') format('svg');
    font-weight: normal;
    font-style: normal;

}

@font-face {
    font-family: 'proxima_nova_ltthin';
    src: url('~@/assets/fonts/ProximaNova/ProximaNovaThin.woff2') format('woff2'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaThin.woff') format('woff'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaThin.ttf') format('truetype'),
        url('~@/assets/fonts/ProximaNova/ProximaNovaThin.svg#proxima_nova_ltthin') format('svg');
    font-weight: normal;
    font-style: normal;
}

@font-face {
  font-family: 'Material Icons';
  font-style: normal;
  font-weight: 400;
  src: url(~@/assets/fonts/MaterialIcons/MaterialIcons-Regular.eot); /* For IE6-8 */
  src: local('Material Icons'),
        local('MaterialIcons-Regular'),
        url(~@/assets/fonts/MaterialIcons/MaterialIcons-Regular.woff2) format('woff2'),
        url(~@/assets/fonts/MaterialIcons/MaterialIcons-Regular.woff) format('woff'),
        url(~@/assets/fonts/MaterialIcons/MaterialIcons-Regular.ttf) format('truetype');
}

.material-icons {
  font-family: 'Material Icons';
  font-weight: normal;
  font-style: normal;
  font-size: 24px;  /* Preferred icon size */
  display: inline-block;
  line-height: 1;
  text-transform: none;
  letter-spacing: normal;
  word-wrap: normal;
  white-space: nowrap;
  direction: ltr;

  /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}

@font-face {
  font-family: 'Avenir LT Std 95 Black';
  font-style: normal;
  font-weight: normal;
  src: local('Avenir LT Std 95 Black'), url('~@/assets/fonts/Avenir/AvenirLTStd-Black.woff') format('woff');
}

.avenir{
  font-family: 'Avenir LT Std 95 Black' !important;
  font-weight: normal;
  font-style: normal;
    /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}

.proxima-semi{
  font-family: 'proxima_nova_ltsemibold';
  font-weight: normal;
  font-style: normal;
    /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}

.proxima{
  font-family: 'proxima_nova_altregular';
  font-weight: normal;
  font-style: normal;
    /* Support for all WebKit browsers. */
  -webkit-font-smoothing: antialiased;
  /* Support for Safari and Chrome. */
  text-rendering: optimizeLegibility;

  /* Support for Firefox. */
  -moz-osx-font-smoothing: grayscale;

  /* Support for IE. */
  font-feature-settings: 'liga';
}

.showScrollbar2, .showScrollbar {
  overflow-y: scroll;
}

.radioTunned.v-input-group.v-input-group--selection-controls .v-input-group__input{
  margin-top: 3px;
}

.radioTunned.v-input-group.v-input-group--selection-controls .v-input-group__input .v-icon--radio{
  color: #82b1ff !important
}

.radioTunned.v-input-group.v-input-group--selection-controls label{
  max-width: calc(100% - 48px);
}

body.hideScrollbar::-webkit-scrollbar{
  overflow-y: scroll;
  opacity: 0;
}

.custom-card{
  cursor: pointer;
}

.titulo-gris{
  font-size: 1.5em;
  color: #747474;
  text-align: center;
}

.carousel-image {
  width: 100%;
  height: 100%;
  min-height: 100px;
  cursor: pointer;
}

.v-carousel__controls{
  background: none
}

.v-carousel__controls__item{
  color: black
}

.v-btn.v-btn--absolute.detail-button{
  padding-right:0;
  font-size: 20px;
  right: 5px;
  bottom: 5px;
}

.v-btn.v-btn--absolute.detail-button .v-btn__content{
  padding: 0 16px;
}
.v-btn.detail-button:not(.v-btn--absolute){
  padding-right:0;
  font-size: 20px;
}

.casiBlanco{
  background-color: #fafafa !important
}

.v-expansion-panel__container.v-expansion-panel__container--active .arrow{
  transform: rotate(180deg)
}

.card-precio{
  font-size: 18px;
  white-space: nowrap;
  margin-top: 10px;
  margin-right: 8px;
}

.estado {
  margin-left:60px
}

.arrow.agrupacionPadre.invertida{
  transform: rotate(180deg) !important;
}

.nombreDocumentacion {
  height: 30px;
  max-height: 30px;
  line-height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: baseline;
  word-break: break-all;
  color: #747474;
  margin:5px;
}

.fullScreenCarousel{
  width:80vw;
  height:80vh;
  pointer-events: none;
}

.fullScreenCarousel button{
  pointer-events: auto;
}

.descripcionText.v-textarea.v-textarea--auto-grow textarea{
  resize: none;
  max-height: 124px;
  overflow-y: auto;
}

a.enlaceDocumentacion {
  margin: 5px;
  text-decoration: none;
  height:40px;
  display:flex;
  align-items:center;
  outline: 1px solid #e5e5e5;
  color: #747474;
}

.arrow.agrupacionPadre:not(.invertida){
  transform: none !important;
}

.textBusqueda {
  margin:8px 9px 19px 29px;max-width:400px
}

.selectEstados.v-select.v-input {
  margin:8px 0px 19px 0px;
  width:300px;
}

.selectEstados.v-select .v-select__selections {
  max-height: 32px;
  overflow: hidden;
  flex-wrap: nowrap;
}

.selectEstados .v-select__selections .v-select__selection--comma {
  max-height: 32px;
  white-space: nowrap;
  flex-shrink: 0;
  overflow: hidden;
  max-width: 100%;
}

.filtroCategorias.v-select.v-input {
  margin:8px 0px 19px 29px;
  max-width:250px;
}

.filtroCategorias.v-select .v-select__selections {
  max-height: 32px;
  overflow: hidden;
  flex-wrap: nowrap;
}

.filtroCategorias .v-select__selections .v-select__selection--comma {
  max-height: 32px;
  white-space: nowrap;
  flex-shrink: 0;
}

.filtroDelegaciones.v-select.v-input {
  margin:8px 0px 19px 29px;
  max-width:250px;
  position: absolute;
  top: -10px;
  right: 0;
}

.filtroDelegaciones.v-select .v-select__selections {
  max-height: 32px;
  overflow: hidden;
  flex-wrap: nowrap;
}

.filtroDelegaciones .v-select__selections .v-select__selection--comma {
  max-height: 32px;
  white-space: nowrap;
  overflow: hidden;
}

.botonNuevoElemento {
  margin-right:29px;
  font-size: 18px;
}

.spanNuevoElemento {
  font-size: 18px;padding-left:10px;padding-right:10px;
}

.padding30 {
  padding:30px;
}

.flexImageUpload {
  width:200px; margin-top:10px; flex-grow:0;
}

.flexFileUpload {
  margin-top:10px; margin-left:20px;
}

.v-expansion-panel__container:not(.v-expansion-panel__container--active) .arrow{
  transform: none;
}

.container.paddingSecondContainer {
  padding-top:6px
}

.absolute {
  position: absolute;
  z-index: 1;
}

.absolute .toolbarPush{
  height: 54px;
}

.precioEstanciaResumen {
  font-size: 16px;
  min-width: 100px;
  text-align: right;
}
.nombreEstanciaResumen {
  font-size: 16px;
}

.precioTotalResumen {
  font-size: 16px;
  min-width: 100px;
  text-align: right;
}
.nombreTotalResumen {
  font-size: 16px;
}

.marginEntreSecciones{
  margin-top:10px
}

.container.bigContainer{
  padding-top:9px;
}

.container.thirdContainer{
  padding-top:0px
}

.redTitle {
  text-transform: uppercase;  margin-bottom:12px
}

.v-expansion-panel__body .theme--light.v-card.gris {
  background-color: #fafafa;
}

.gris{
  color: #747474;
}

.arbolEllipsis {
  height: 40px;
  max-height: 40px;
  line-height: 40px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: baseline;
  word-break: break-all;
}

.subtituloEllipsis {
  height: 31px;
  max-height: 31px;
  line-height: 31px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: baseline;
  word-break: break-all;
}

.columnaCaracteristicas {
  height: 21px;
  max-height: 21px;
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: baseline;
  word-break: break-all;
}

.labelVerEllipsis {
  height: 24px;
  max-height: 24px;
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: baseline;
  word-break: break-all;
}

.subepigrafeEllipsis {
  height: 36px;
  max-height: 36px;
  line-height: 36px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  align-self: baseline;
  word-break: break-all;
}

.treeNodeImage{
  width: 60px;
  margin: 0px;
}

.margenesFicha{
  margin-left:25px;
  margin-right:25px;
}

.tituloSeccion{
  font-size:16px
}

.btnVolver {
  margin: 6px 0px 0 0
}

.btnVolver .v-btn__content {
  padding:0;
}

.rowBusquedaBoton {
  margin-top:0px;
  margin-left:20px;
  margin-right:20px
}

.subtitulo_popUp {
  margin: 20px 120px 0px 120px
}


.dividerTitle.v-divider {
  border-top:3px;
  border-style: solid;
  border-color: #2c61a0;
  margin-left:100px;
  margin-right:100px
}

.divider_subtitle.v-divider {
  border-top:2px;
  border-style: solid;
  border-color: #2c61a0;
  background-color: #2c61a0;
}

.imagenVerForm {
  width:150px;flex-grow:0;
}

ul.v-breadcrumbs{
  padding: 0px
}

.v-breadcrumbs li:nth-child(even) {
    padding: 0 4px;
}

.v-breadcrumbs__divider{
  padding: 0px
}

.v-card__title.titulo_popUp{
  padding-bottom: 0px;
  padding-top: 10px;
}

.v-card__title {
  word-break: break-word;
}

.fechaFinVigenciaCheck.v-input.v-input--selection-controls {
  margin: 0px;
  padding: 0px;
  justify-content: center;
  display: flex;
}

.fechaFinVigenciaCheck.v-input.v-input--selection-controls label {
  line-height: 22px;
  height: 22px;
  font-size: 16px !important;
  font-weight: 400;
  width: auto;
}

.fechaFinVigenciaCheck.error--text.v-input.v-input--selection-controls label.v-label {
  color: #ff4f37;
}

.checkBoxAnadir.v-input.v-input--selection-controls {
  justify-content: center;
  margin: 0px;
  padding-top:0px;
}

.checkboxDeshabilitado.v-input-group.v-input-group--disabled label{
  cursor: default;
}

.checkboxDeshabilitado.v-input-group.v-input-group--disabled i{
  cursor: default;
}

.checkboxDeshabilitado.v-input-group.v-input-group--disabled .v-input-group--selection-controls__ripple{
  cursor: default;
}

.checkboxDeshabilitado.v-input-group.v-input-group--selection-controls.v-switch .v-input-group--selection-controls__ripple:after{
  cursor: default;
}

.notClicable{
  pointer-events: none;
}

.notClicable .v-expansion-panel__body{
  pointer-events: auto;
}

.noCursor{
  cursor: default !important;
}


.noCursor.header .v-expansion-panel__header button{
  pointer-events: auto;
}

.checkBoxAnadir.v-input-group.v-input-group--selection-controls label{
  font-size: 16px !important;
  font-weight: 400;
}

.checkBoxAnadir.v-input-group.v-input-group--selection-controls .v-input-group__input{
  margin-top:2px
}

.fechaFinVigenciaCheck .v-input-group__details{
  min-height: 0px;
  display: none;
}

.fechaFinVigenciaCheck.v-input-group.v-input-group--selection-controls .v-input-group__input .v-icon--selection-control{
  height: inherit
}

.links-no--style {
  text-decoration: none;
  font-size: .8rem;
  font-weight: 600;
}


.selectEstadosInformes .v-select__selections .v-select__selection--comma {
  max-height: 32px;
  white-space: nowrap;
}

.selectEstadosInformes.v-select .v-select__selections {
  max-height: 32px;
  overflow: hidden;
}
.theme--light .v-text-field.v-input--is-readonly,
.application .theme--light.v-text-field.v-input--is-readonly {
  pointer-events: none;
}
.theme--light .v-navigation-drawer .v-list {
  background: inherit;
}
.v-breadcrumbs__item {
  font-size: 12px;
}
.v-breadcrumbs__divider {
  font-size: 12px;
}
.v-breadcrumbs__item.breadcrumbs__item--disabled {
  font-size: 12px;
}
.container {
  padding: 16px;
}
.v-toolbar__content,
.v-toolbar__extension {
  padding: 0 16px;
}
.v-list.v-list--dense .v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0px;
}
.application .v-input--selection-controls {
  padding-top: 0;
  margin-top: 0;
}
.full-width.v-input--selection-controls .v-input__control {
  width: 100%;
}
.v-card.mostrarSombra {
  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);
}

.v-navigation-drawer__content {
  background-color: #2c61a0 !important;
}
.v-data-table-header-mobile__wrapper {
  width: 85px !important;
}
/*
th div.v-simple-checkbox {
  display: none !important;
}
*/
.theme--dark.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  color: grey !important;
  background: rgba(221, 220, 220, .7) !important;
}
.textoAjustado {
  word-break: break-word;
}
.transparentTabs .v-tabs-items {
  background: transparent !important;
}

.contenedorPrincipal {
    padding: 10px !important;
}
.pd-top-15{
  padding-top: 15px;
}

</style>
